import * as React from "react";
import { TSetUrlParamsArgs } from "../../../../hooks/useXoraia";
import { IXCategoryFilterProps } from "../../../../utils/interfaces/containers/XCategoryFilter.interfaces";
import { Grid } from "../../../core/Grid";
import { IArticleData } from "../../../../utils/interfaces/common/XArticle.interfaces";
import XArticleProvider from "../../../../context/XArticleProvider";
import XArticle from "../../../common/XArticle";

const GridArticleList: React.FC<
  IXCategoryFilterProps & {
    onChange: (args: TSetUrlParamsArgs) => Promise<void>;
    urlParams: TSetUrlParamsArgs;
    articles?: IArticleData[];
  }
> = (props) => {
  return (
    <Grid columns={props.columns} gap={props.gap}>
      {(props.articles ?? []).map((article, i) => {
        const id = article.id ?? i.toString();

        return (
          <XArticleProvider data={article} key={id}>
            <XArticle index={id} />
          </XArticleProvider>
        );
      })}
    </Grid>
  );
};

export default GridArticleList;
